import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import NoteTag from '@components/framework/tags/NoteTag.tsx';
import { SecuredConfig } from '@components/security/securedDecoration';

interface ComponentProps {
  reservationNote: string;
  onChange: (note: string) => void;
  readOnly?: boolean;
  maxLength?: number;
  dataTestId?: string;
  secured?: SecuredConfig;
}

const ReservationNoteTag: React.FC<ComponentProps> = ({ reservationNote, onChange, readOnly, maxLength, dataTestId, secured }) => {
  const { tr } = useTranslationLgs();

  return (
    <>
      <NoteTag
        label={tr(`ReservationNoteTag.title`, `Reservation note`)}
        note={reservationNote}
        onChangeNote={v => onChange(v)}
        formated={true}
        readOnly={readOnly}
        maxLength={maxLength}
        dataTestId={dataTestId}
        secured={secured}
      />
    </>
  );
};

export default ReservationNoteTag;
